<template>
  <main id="create-item-page" class="page-container">
    <!-- Messaggi di errore/successo -->
    <!-- <p
      v-if="errorMessage"
      :class="{ 'error-message': true, show: errorMessage }"
    >
      {{ errorMessage }}
    </p>
    <p
      v-if="successMessage"
      :class="{ 'success-message': true, show: successMessage }"
    >
      {{ successMessage }}
    </p> -->

    <section class="edit-layout stacked">
      <!-- usa 'stacked' per A) -->
      <!-- Anteprima immagine (se presente e se non si sta caricando una nuova immagine) -->
      <div
        v-if="formData.image && typeof formData.image === 'string'"
        class="image-preview"
      >
        <img
          :src="formData.image"
          alt="Anteprima immagine"
          class="mini-image-preview"
        />

        <button
          v-if="formData.image"
          class="image-clear-btn"
          @click="promptRemoveImage()"
          title="Rimuovi immagine"
          aria-label="Rimuovi immagine"
        >
          <font-awesome-icon :icon="['fas', 'xmark']" />
        </button>
      </div>

      <!-- Form principale -->
      <form class="create-item-form" @submit.prevent="onUpdateItem">
        <div class="create-item-row">
          <!-- Modello -->
          <div class="field">
            <label for="item-model">Modello</label>
            <input
              id="item-model"
              type="text"
              v-model="formData.model"
              placeholder="inserisci"
            />
          </div>
          <!-- Nome Articolo -->
          <div class="field">
            <label for="item-name">Nome articolo</label>
            <input
              id="item-name"
              type="text"
              v-model="formData.itemName"
              placeholder="inserisci"
            />
          </div>
          <!-- Categoria -->
          <div class="field">
            <label for="category">Categoria</label>
            <input
              id="category"
              type="text"
              v-model="formData.category"
              placeholder="inserisci"
            />
          </div>
          <!-- Quantità -->
          <div class="field">
            <label for="quantity">Quantità</label>
            <input
              id="quantity"
              type="text"
              v-model="formData.quantity"
              placeholder="inserisci"
            />
          </div>
          <!-- Data inserimento -->
          <div class="field">
            <label for="date">Data inserimento</label>
            <input
              id="date"
              type="date"
              v-model="formData.entryDate"
              placeholder="inserisci"
            />
          </div>
          <!-- Immagine -->
          <div class="field file-field">
            <label for="image">
              {{ imageFileName ? "Immagine caricata" : "Carica un'immagine" }}
            </label>

            <div class="custom-file">
              <input
                id="image"
                type="file"
                @change="handleImageUpload"
                accept="image/*"
                class="visually-hidden"
              />
              <label class="choose-btn" for="image">Scegli file</label>
              <span v-if="selectedFileName" class="file-name">
                {{ selectedFileName }}
              </span>
              <span
                v-else-if="formData.image && typeof formData.image === 'string'"
                class="file-name existing"
              >
                File già caricato: {{ imageFileName }}
              </span>
              <span v-else class="file-name placeholder">
                Nessun file selezionato
              </span>
            </div>
          </div>

          <!-- Bottone "Aggiorna" -->
          <div class="save-button-container">
            <button id="create-item-button" type="submit">Aggiorna</button>
          </div>
        </div>
        <hr />
      </form>
    </section>

    <!-- ▸ MODALE RIMOZIONE IMMAGINE -->
    <div v-if="showRemoveImageModal" class="modal-overlay">
      <div class="modal">
        <button
          class="modal__close icons-button"
          @click="cancelRemoveImage"
          title="Chiudi"
          aria-label="Chiudi"
        >
          <font-awesome-icon :icon="['fas', 'xmark']" />
        </button>

        <h3 class="modal__title">Rimuovere l’immagine?</h3>
        <p class="modal__subtitle">
          Stai per rimuovere <strong>{{ imageFileName }}</strong> dall’articolo
          <strong>{{ formData.itemName }}</strong
          >. Confermi?
        </p>

        <div class="modal-actions">
          <button class="primary-btn" @click="confirmRemoveImage">
            Rimuovi
          </button>
          <!-- <button class="secondary-btn" @click="cancelRemoveImage">Annulla</button> -->
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { mapActions } from "vuex/dist/vuex.cjs.js";
import { useToast } from "vue-toast-notification";

export default {
  setup() {
    const toast = useToast();
    return { toast };
  },
  name: "EditItemPage",
  props: ["itemId"],
  data() {
    return {
      formData: {
        model: "",
        itemName: "",
        category: "",
        quantity: "",
        entryDate: "",
        // Qui, se l'articolo ha già un'immagine, potresti inizializzarla con l'URL permanente già presente.
        image: null,
      },
      // errorMessage: "",
      // successMessage: "",
      showRemoveImageModal: false,
      selectedFileName: "",
    };
  },
  computed: {
    // Se formData.image è una stringa (URL), estrai il nome del file
    imageFileName() {
      if (this.formData.image && typeof this.formData.image === "string") {
        return this.formData.image.split("/").pop();
      }
      return "";
    },
  },
  methods: {
    ...mapActions(["updateItem", "uploadImage", "removeImage"]),

    async fetchItemData() {
      try {
        // this.errorMessage = "";
        const response = await this.$axios.get(`item/${this.itemId}`);

        if (response.status === 200) {
          const itemData = response.data.item;
          this.formData.model = itemData.model;
          this.formData.itemName = itemData.itemName;
          this.formData.category = itemData.category;
          this.formData.quantity = itemData.quantity;
          this.formData.entryDate = itemData.entryDate
            ? itemData.entryDate.slice(0, 10)
            : "";
          // Se l'articolo ha già un'immagine, la salvi come stringa (URL permanente)
          this.formData.image = itemData.image;

          // Se l'articolo ha già un'immagine, mostra il nome file nel campo
          if (itemData.image && typeof itemData.image === "string") {
            this.selectedFileName = itemData.image.split("/").pop();
          }

          // this.$nextTick(() => {
          // this.successMessage =
          this.toast.success(
            response.data?.message || "Dati articolo caricati con successo."
          );
          // });
        }
      } catch (error) {
        // this.errorMessage =
        this.toast.error(
          error.response?.data?.message ||
            "Impossibile caricare i dati dell'articolo."
        );
      }
    },

    // apre il modale
    promptRemoveImage() {
      if (!this.formData.image || typeof this.formData.image !== "string")
        return;
      this.showRemoveImageModal = true;
      this.selectedFileName = "";
    },

    // chiude il modale
    cancelRemoveImage() {
      this.showRemoveImageModal = false;
    },

    // conferma rimozione immagine (logica ex clearImage, senza window.confirm)
    async confirmRemoveImage() {
      try {
        const objectName = this.formData.image.split("/").pop();
        await this.removeImage({ itemId: this.itemId, objectName });

        this.formData.image = null;
        // this.successMessage =
        this.toast.success("Immagine rimossa con successo.");
      } catch (error) {
        // console.error(error);
        // this.errorMessage =
        this.toast.error("Errore nella rimozione dell'immagine.");
      } finally {
        this.showRemoveImageModal = false;
        // setTimeout(() => {
        //   this.successMessage = "";
        //   // this.errorMessage = "";
        // }, 1500);
      }
    },

    handleImageUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.formData.image = file; // Seleziona il file solo se l'utente ne carica uno nuovo
        this.selectedFileName = file.name;
      }
    },

    async onUpdateItem() {
      // this.errorMessage = "";
      // this.successMessage = "";
      try {
        let imageUrl = "";

        // Se l'immagine è un file (cioè l'utente ha selezionato una nuova immagine),
        // effettua l'upload e costruisci l'URL permanente
        if (this.formData.image && this.formData.image instanceof File) {
          const uploadResponse = await this.$store.dispatch("uploadImage", {
            image: this.formData.image,
          });
          imageUrl = uploadResponse.data.url;
        } else if (typeof this.formData.image === "string") {
          // Se l'immagine è già una stringa (URL permanente), la mantieni
          imageUrl = this.formData.image;
        }

        // Prepara il payload per aggiornare l'articolo
        // Includi il campo image solo se è stato aggiornato (cioè se imageUrl è valorizzato)
        const payload = {
          model: this.formData.model,
          itemName: this.formData.itemName,
          category: this.formData.category,
          quantity: this.formData.quantity,
          entryDate: this.formData.entryDate,
          ...(imageUrl && { image: imageUrl }),
        };

        const response = await this.$store.dispatch("updateItem", {
          itemId: this.itemId,
          payload,
        });

        if (response.status === 200) {
          // this.$nextTick(() => {
          // this.successMessage =
          this.toast.success(
            response.data?.message || "Articolo aggiornato con successo!"
          );
          // });
          // Redirect alla pagina stock dopo un breve timeout
          setTimeout(() => {
            this.$router.push({ name: "stock" });
          }, 1000);
        }
      } catch (error) {
        if (error.response?.status === 409) {
          // this.$nextTick(() => {
          // this.errorMessage =
          this.toast.error(
            error.response.data?.details ||
              "Conflitto nei dati, chiave univoca 'Nome articolo' già presente."
          );
          // });
        } else {
          // this.$nextTick(() => {
          // this.errorMessage =
          this.toast.error(
            error.response?.data?.details ||
              error.response?.data?.error ||
              "Errore durante l'aggiornamento dell'articolo."
          );
          // });
        }
        // this.successMessage = "";
      }
    },
  },
  mounted() {
    this.fetchItemData();
  },
};
</script>

<style src="@/css/CreateItemPage.css"></style>
